import { Container } from "@pixi/display";
import { IPage } from "./IPage";

export class BasePage extends Container implements IPage {
    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }
}